import React from 'react';
import './LandingPageV2.css';

function PrivacyPage() {
  return (
    <div className="landing-v2">
      {/* Reuse landing header for consistent visual identity (without locale switcher) */}
      <header className="landing-v2-header">
        <div className="header-container">
          <div className="logo">
            <img
              src={process.env.PUBLIC_URL + '/logo512.png'}
              alt="Supchats logo"
              className="logo-img"
            />
            <span className="logo-text">Supchats</span>
          </div>
        </div>
      </header>

      <div className="public-page">
        <div className="public-hero">
          <h1>Privacy Policy</h1>
          <p>
            This Privacy Policy explains how Supchats collects, uses, stores and
            protects personal data when you use our website, chat widget and
            admin dashboard.
          </p>
        </div>

        <div className="public-section">
          <h2>1. Who we are</h2>
          <p>
            Supchats is a live‑chat and AI assistant service provided by
            TecophoneLTD (Kypranoros, 13 EVI BUILDING, 2nd floor, office 201,
            1061, Nicosia, Cyprus). For the purposes of GDPR, we act as a data
            controller for your account data and as a data processor for
            end‑user data you send us through the widget.
          </p>
        </div>

        <div className="public-section">
          <h2>2. Data we process</h2>
          <ul>
            <li>
              <strong>Account data</strong>: email address, name, company
              details, billing data (if applicable) and security settings needed
              to create and maintain your Supchats account.
            </li>
            <li>
              <strong>Chat and widget data</strong>: messages, attachments and
              metadata exchanged via the Supchats widget and admin panel,
              including visitor identifiers (such as cookies, persistent IDs or
              client UIDs you pass to us).
            </li>
            <li>
              <strong>Usage and technical data</strong>: IP address,
              browser/device information, timestamps, log events and performance
              metrics used for security, abuse‑prevention and service quality.
            </li>
          </ul>
        </div>

        <div className="public-section">
          <h2>3. Purposes and legal bases</h2>
          <p>We process data for the following purposes and on these bases:</p>
          <ul>
            <li>
              <strong>Service delivery</strong> (performing our contract with
              you): providing the chat widget, AI features, dashboard and
              support.
            </li>
            <li>
              <strong>Service improvement and analytics</strong> (our legitimate
              interest): monitoring performance, improving features and
              preventing abuse, while respecting your privacy.
            </li>
            <li>
              <strong>Legal and compliance</strong> (legal obligation): keeping
              records required by tax, accounting and security laws.
            </li>
            <li>
              <strong>Marketing communications</strong> (consent/legitimate
              interest): sending product updates or offers, where permitted and
              with an easy opt‑out.
            </li>
          </ul>
        </div>

        <div className="public-section">
          <h2>4. How long we keep data</h2>
          <p>
            We retain personal data only for as long as necessary to provide the
            service to you, comply with our legal obligations or resolve
            disputes. Chat histories can be deleted or anonymized by you in the
            dashboard, and you may request deletion of your account at any time
            via support.
          </p>
        </div>

        <div className="public-section">
          <h2>5. Sharing and sub‑processors</h2>
          <p>
            We do not sell personal data. We may share data with carefully
            selected sub‑processors (for example hosting, email delivery, error
            monitoring and analytics providers) strictly for the purpose of
            operating Supchats. These providers are bound by data‑processing
            agreements and confidentiality obligations.
          </p>
        </div>

        <div className="public-section">
          <h2>6. International data transfers</h2>
          <p>
            Where data is transferred outside the European Economic Area, we
            rely on appropriate safeguards such as Standard Contractual Clauses
            or equivalent legal mechanisms, and we only use providers that
            commit to GDPR‑level protections.
          </p>
        </div>

        <div className="public-section">
          <h2>7. Security</h2>
          <p>
            We apply technical and organizational measures to protect data,
            including TLS encryption in transit, access controls, audit logging
            and regular security reviews. No system is perfectly secure; if you
            suspect an incident, please contact us immediately.
          </p>
        </div>

        <div className="public-section">
          <h2>8. Your rights</h2>
          <p>
            Depending on your location, you may have the right to access,
            rectify, erase or restrict processing of your personal data, as well
            as the right to data portability and to object to certain
            processing. To exercise these rights, contact us using the details
            below. As a customer, you are responsible for handling requests from
            your own end‑users and may use our tools to help you do so.
          </p>
        </div>

        <div className="public-section">
          <h2>9. Cookies and similar technologies</h2>
          <p>
            Supchats uses cookies and similar technologies to operate the
            widget, remember sessions and provide secure access to the
            dashboard. You can control cookies via your browser settings, but
            disabling essential cookies may impact the service.
          </p>
        </div>

        <div className="public-section">
          <h2>10. Data protection and data processing</h2>
          <p>
            When you install the Supchats widget on your site, you act as the
            data controller for your visitors&apos; personal data, and Supchats
            acts as your data processor. You are responsible for providing
            appropriate privacy notices to your visitors and obtaining any
            required consents. We process end‑user data only on your documented
            instructions and in line with this Privacy Policy and any separate
            Data Processing Agreement we may sign with you.
          </p>
        </div>

        <div className="public-section">
          <h2>11. Contact</h2>
          <p>
            If you have questions about this Privacy Policy or our data
            practices, contact us at{' '}
            <a href="mailto:support@supchats.com">support@supchats.com</a> or by
            mail at TecophoneLTD, Kypranoros, 13 EVI BUILDING, 2nd floor, office
            201, 1061, Nicosia, Cyprus.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;

